import { isDate } from 'lodash';

export function getRegionName(state, getters) {
  return getters.getProficiencyRank.region;
}

export function getDistrictTotal(state, getters) {
  return getters.getProficiencyRank.district_total;
}

export function isDistrictTotal(state, getters) {
  return getters.getProficiencyRank.district_total >= 10;
}

export function getDistrictPosition(state, getters) {
  return getters.getProficiencyRank.district_position;
}

export function getDistrictRate(state, getters) {
  return Number(((getters.getDistrictPosition /
    getters.getDistrictTotal) * 100)) || 0;
}

export function getPrevDistrictPosition(state, getters) {
  return getters.getPreviousProficiencyRank.district_position || 0;
}

export function getPrevDistrictTotal(state, getters) {
  return getters.getPreviousProficiencyRank.district_total || 0;
}

export function getPrevDistrictRate(state, getters) {
  return Number(((getters.getPrevDistrictPosition /
    getters.getPrevDistrictTotal) * 100)) || 0;
}

export function getChangedDistrictRate(state, getters) {
  if (getters.getPrevDistrictRate === 0) {
    return 0;
  }

  return Number((((getters.getPrevDistrictRate - getters.getDistrictRate) * 100)
    / getters.getPrevDistrictRate)) || 0;
}

export function getHistoryScoresData(state, getters) {
  return getters.getOrderProficiencyHistory.map(item => (
    item.proficiency_score || 0
  ));
}

export function getHistoryScoresDates(state, getters) {
  return getters.getOrderProficiencyHistory.map(item => (
    item.updated_at || ''
  ));
}

export function getHistoryScoreDateLabels(state, getters) {
  return getters.getHistoryScoresDates.map((item) => {
    if (item === '') {
      return item;
    }

    const date = isDate(item) ? item : new Date(item.slice(0, 10));
    return `${date.getMonth() + 1}.${date.getDate()}`;
  });
}

export function getDomain(state) {
  return state.domain || {};
}

export function getLearningElement(state) {
  return state.learningElement;
}

export function getDomainProficiencyRank(state) {
  return state.domainProficiencyRank;
}



// WEBPACK FOOTER //
// ./src/app/cat-proficiency/store/getters.js